import LICENSE_INFORMATION_HOLDER_TYPES from './licenseInformationHolderTypes';

const LICENSE_INFORMATION_TYPE_DISPLAY_NAMES = new Map([
  [LICENSE_INFORMATION_HOLDER_TYPES.Organization, 'Organization'],
  [LICENSE_INFORMATION_HOLDER_TYPES.OrgUnit, 'Unit']
]);

export default LICENSE_INFORMATION_TYPE_DISPLAY_NAMES;
